import { useState } from 'react';
import {
  IonPage,
  IonHeader,
  IonToolbar,
  IonButtons,
  IonMenuButton,
  IonButton,
  IonTitle,
  IonContent,
  IonList,
  IonText
} from '@ionic/react';

import classes from './style.module.scss';

const services = [
  {
    service: 'Initial Evaluation',
    location: 'Deerfield Beach',
    link: 'https://barwis.janeapp.com/locations/barwis-methods-physical-therapy-south-florida/book#/discipline/1/treatment/1'
  },
  {
    service: 'Physical Therapy 1 Hour',
    location: 'Deerfield Beach',
    link: 'https://barwis.janeapp.com/locations/barwis-methods-physical-therapy-south-florida/book#/discipline/1/treatment/2'
  },
  {
    service: 'Telehealth Initial Evaluation',
    location: 'Deerfield Beach',
    link: 'https://barwis.janeapp.com/locations/barwis-methods-physical-therapy-south-florida/book#/discipline/1/treatment/487'
  },
  {
    service: 'Telehelath Physical Therapy (30 min)',
    location: 'Deerfield Beach',
    link: 'https://barwis.janeapp.com/locations/barwis-methods-physical-therapy-south-florida/book#/discipline/1/treatment/488'
  },
  {
    service: 'ARS Screen (by DPT)',
    location: 'Deerfield Beach',
    link: 'https://barwis.janeapp.com/locations/barwis-methods-physical-therapy-south-florida/book#/discipline/1/treatment/625'
  },
  {
    service: 'Chiropractic Follow-Up',
    location: 'Deerfield Beach',
    link: 'https://barwis.janeapp.com/locations/barwis-chiropractic/book#/staff_member/3/treatment/10'
  },
  {
    service: 'Chiropractic Extended Follow-Up',
    location: 'Deerfield Beach',
    link: 'https://barwis.janeapp.com/locations/barwis-chiropractic/book#/staff_member/3/treatment/11'
  },
  {
    service: 'Chiropractic Evaluation Visit',
    location: 'Deerfield Beach',
    link: 'https://barwis.janeapp.com/locations/barwis-chiropractic/book#/staff_member/3/treatment/267'
  },
  {
    service: 'Virtual Personal Training',
    location: 'Deerfield Beach',
    link: 'https://barwis.janeapp.com/locations/barwis-performance-center-of-south-florida/book#/discipline/42/treatment/492'
  },
  {
    service: 'Personal Training',
    location: 'Deerfield Beach',
    link: 'https://barwis.janeapp.com/locations/barwis-performance-center-of-south-florida/book#/discipline/3/treatment/8'
  },
  {
    service: 'ARS Screen (By trainers)',
    location: 'Deerfield Beach',
    link: 'https://barwis.janeapp.com/locations/barwis-performance-center-of-south-florida/book#/discipline/3/treatment/504'
  },
  {
    service: 'BARWIS Built Personalized Training Program',
    location: 'Deerfield Beach',
    link: 'https://form.jotform.com/50896935457977'
  },
  {
    service: 'Neurological Assessment',
    location: 'Deerfield Beach',
    link: 'https://form.jotform.com/211744032982151'
  }
];

const ServicesPage = () => {
  const [curServiceIndex, setCurServiceIndex] = useState();

  return (
    <IonPage id='services'>
      <IonHeader>
        <IonToolbar>
          <IonButtons slot='start'>
            <IonMenuButton></IonMenuButton>
          </IonButtons>
          <IonTitle>Services</IonTitle>
        </IonToolbar>
      </IonHeader>
      <IonContent className={classes.ionContent}>
        <IonList>
          {services.map((service, index) => (
            <div key={service.service} className={classes.serviceItem}>
              <div
                onClick={() => setCurServiceIndex(index)}
                className={`${classes.serviceItemTitle} ${
                  curServiceIndex === index
                    ? classes.serviceItemTitleSelected
                    : ''
                }`}
              >
                <IonText>{service.service}</IonText>
              </div>
              {curServiceIndex === index && (
                <IonButton
                  expand='full'
                  size='small'
                  href={service.link}
                  rel='external'
                  target='_blank'
                >
                  Book Now
                </IonButton>
              )}
            </div>
          ))}
        </IonList>
      </IonContent>
    </IonPage>
  );
};

export default ServicesPage;
